/// <amd-module name="Artifacts/Feed/components/DeletedFeed" />

import * as Res from "Artifacts/Feed/Resources";
import { isUserAnonymousOrPublic } from "Artifacts/Root/helpers/UserHelpers";
import { settingsRoute } from "Artifacts/Root/routing/Constants";
import { IFeed } from "Artifacts/Root/types";
import * as React from "react";
import { useEffect, useState } from "react";
import { generatePath, useHistory } from "react-router-dom";
import { useComponentContext } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { Page } from "VSSUI/Page";
import { ZeroData, ZeroDataActionType } from "VSSUI/ZeroData";

interface IDeletedFeedProps {
  feed?: IFeed;
}

export const DeletedFeed: React.FC<IDeletedFeedProps> = ({ feed }) => {
  const { pageContext } = useComponentContext();
  const [isUserAnonymousOrPublicConst, setIsUserAnonymousOrPublicConst] = useState<
    boolean | undefined
  >();
  const history = useHistory();

  useEffect(() => {
    setIsUserAnonymousOrPublicConst(isUserAnonymousOrPublic(pageContext));
  }, [pageContext]);

  const imagePath = getAssetLocation(pageContext, "ms.azure-artifacts/feed/img/deleted-feed.svg");
  return isUserAnonymousOrPublicConst != null ? (
    <Page className="feed-hub">
      <ZeroData
        primaryText={Res.DeletedFeedPanel_Message}
        secondaryText={Res.DeletedFeedPanel_Secondary_Message}
        imagePath={imagePath}
        imageAltText=""
        actionText={isUserAnonymousOrPublicConst ? undefined : Res.FeedSettings}
        actionType={isUserAnonymousOrPublicConst ? undefined : ZeroDataActionType.ctaButton}
        onActionClick={
          isUserAnonymousOrPublicConst
            ? undefined
            : () => history.push(generatePath(settingsRoute, { feedIdentifier: feed?.name }))
        }
      />
    </Page>
  ) : null;
};
